import { render } from "./AdminCoursesLocations.vue?vue&type=template&id=0644099c"
import script from "./AdminCoursesLocations.vue?vue&type=script&lang=js"
export * from "./AdminCoursesLocations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__